class CookieBanner extends ModalElement {
    constructor() {
        super(), theme.config.isTouch ? new theme.initWhenVisible(this.init.bind(this)) : this.init()
    }
    get testMode() {
        return "true" === this.dataset.testMode
    }
    get delay() {
        return parseInt(this.dataset.delay) || 5
    }
    get acceptButton() {
        return this.querySelector('button[name="accept"]')
    }
    get declineButton() {
        return this.querySelector('button[name="decline"]')
    }
    init() {
        this.testMode ? this.load(this.delay) : window.Shopify.loadFeatures([{
            name: "consent-tracking-api",
            version: "0.1",
            onLoad: this.onConsentLibraryLoaded.bind(this)
        }])
    }
    load(e) {
        Shopify && Shopify.designMode || (setTimeout((() => this.show()), 1e3 * e), this.acceptButton && this.acceptButton.addEventListener("click", this.acceptPolicy.bind(this)), this.declineButton && this.declineButton.addEventListener("click", this.declinePolicy.bind(this)))
    }
    acceptPolicy() {
        this.hide(), window.Shopify.customerPrivacy?.setTrackingConsent(!0, this.noop), document.addEventListener("trackingConsentAccepted", (() => {
            console.log("trackingConsentAccepted event fired")
        }))
    }
    declinePolicy() {
        this.hide(), window.Shopify.customerPrivacy?.setTrackingConsent(!1, this.noop)
    }
    onConsentLibraryLoaded() {
        const e = window.Shopify.customerPrivacy.userCanBeTracked(),
            t = window.Shopify.customerPrivacy.getTrackingConsent();
        e || "no_interaction" !== t || this.load(this.delay)
    }
    noop() {}
    afterHide() {
        super.afterHide(), document.body.classList.remove("has-cookie-banner")
    }
    afterShow() {
        super.afterShow(), document.body.classList.add("has-cookie-banner")
    }
}
customElements.define("cookie-banner", CookieBanner);